import React from "react";
import Step from "components/MainApp/atoms/Wizard/Step";

import styles from "./Step3.module.scss";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

export class AddBusinessNodeStepThree extends React.Component {
  render() {
    const { description, contact, goBack, handleFinish } = this.props;

    const stepContent = (
      <form onSubmit={handleFinish}>
        <div className={styles["add-provider-wizard-step-three-content"]}>
          <div className={styles["add-provider-wizard-step-three-title"]}>
            {capitalize(i18n.t("description"))}
          </div>
          {description.map((item, index) => {
            return (
              <div
                key={index}
                className={styles["add-provider-wizard-step-three-item"]}
              >
                <div className={styles["add-provider-wizard-step-three-title"]}>
                  {item.title}
                </div>
                <div className={styles["add-provider-wizard-step-three-value"]}>
                  {item.value}
                </div>
              </div>
            );
          })}

          <div className={styles["add-provider-wizard-step-three-title"]}>{i18n.t("contact")}</div>

          {contact.map((item, index) => {
            return (
              <div
                key={index}
                className={styles["add-provider-wizard-step-three-item"]}
              >
                <div className={styles["add-provider-wizard-step-three-title"]}>
                  {item.title}
                </div>
                <div className={styles["add-provider-wizard-step-three-value"]}>
                  {item.value}
                </div>
              </div>
            );
          })}

          <div className={styles["add-provider-wizard-step-three-action-wrapper"]}>
            <button
              type="submit"
              className={styles["add-provider-wizard-step-three-action-button"]}
            >
              {i18n.t("finish").toUpperCase()}
            </button>
          </div>
        </div>
      </form>
    );

    return (
      <div className={styles["add-provider-wizard-step-three-container"]}>
        <Step
          title={i18n.t("confirmation")}
          content={stepContent}
          goBackFunc={goBack}
        ></Step>
      </div>
    );
  }
}

export default AddBusinessNodeStepThree;
